module.exports = __webpack_public_path__ + "static/media/courses3.192a0945.png";